module.exports = __webpack_public_path__ + "img/pdf-file.dcd3164c.svg";